// jshint esversion: 8
export default {
  id: null,
  username: null,
  email: null,
  first_name: null,
  last_name: null,
  image: null,
  department: null,
  location: null
}
